import * as React from 'react';

import Portal from 'src/portals/Portal';
import Header from 'src/components/Header';
import HeaderBanner from 'src/components/HeaderBanner';
import Menu from 'src/components/Menu';
import {
  ifLoggedIn,
  goToSearch,
  goToModelDetail,
  goToPartDetail
} from 'src/utils/navigation';
import FeedbackView from 'src/pages/FeedbackView';

export class Static extends React.Component<{}, {}> {
  private onSubmitSearch = (text: string) => {
    ifLoggedIn(() => goToSearch(text));
  };

  private onSearchSelectedPart = (text: string) => {
    ifLoggedIn(() => goToPartDetail(text));
  };

  private onSearchSelectedModel = (name: string, manufacturer: string) => {
    ifLoggedIn(() => goToModelDetail(name, manufacturer));
  };

  public render() {
    return (
      <div>
        <Portal idElementToRender={'specialuserbanner'}>
          <HeaderBanner />
        </Portal>
        <Portal idElementToRender={'header'}>
          <Menu
            content={true}
            handleOnSubmitSearch={this.onSubmitSearch}
            handleOnSearchSelectedPart={this.onSearchSelectedPart}
            handleOnSearchSelectedModel={this.onSearchSelectedModel}
          />
          <FeedbackView />
        </Portal>
        <Portal idElementToRender={'searchbar'}>
          <Header
            handleOnSubmitSearch={this.onSubmitSearch}
            handleOnSearchSelectedPart={this.onSearchSelectedPart}
            handleOnSearchSelectedModel={this.onSearchSelectedModel}
            shouldShowSearchDropdown={true}
          />
        </Portal>
      </div>
    );
  }
}
